import React, { useEffect } from 'react';
import { AfriCardComparePage } from './pages/AfriCardComparePage';
import { TermsPage } from './pages/TermsPage';
import { initAnalytics } from './utils/analytics';
import { useExchangeRates } from './hooks/useExchangeRates';
import { LanguageProvider } from './contexts/LanguageContext';
export function App() {
  // Fetch and subscribe to exchange rates from Supabase
  const {
    isLoading,
    error,
    lastUpdated
  } = useExchangeRates();
  useEffect(() => {
    // Initialize Mixpanel when app loads
    initAnalytics();
  }, []);
  // Optional: Show loading or error states
  if (error) {
    console.warn('Using default rates due to error:', error);
  }
  // Simple routing based on pathname
  const path = window.location.pathname;
  return <LanguageProvider data-id="element-0">
      {path === '/terms' ? <TermsPage data-id="element-1" /> : <AfriCardComparePage data-id="element-2" />}
    </LanguageProvider>;
}